module.exports = __webpack_public_path__ + "static/media/zizhi.879d8641.jpg";